<div [ngClass]="isLoading ? 'd-block' : 'd-none'">
    <div class="card">
        <div class="row">
            <div class="col-md-4 d-none d-md-block">
                <app-card-skeletal [rows]="1" [cardsPerRow]="1" [cardHeight]="310"></app-card-skeletal>
            </div>
            <div class="col-md-8">
                <app-card-skeletal [rows]="5" [cardsPerRow]="1" [cardHeight]="50"></app-card-skeletal>
            </div>
        </div>
    </div>
</div>

<div [ngClass]="!isLoading ? 'd-block' : 'd-none'">
    <div [ngClass]="paymentSession?.sessionToken !== '' ? 'd-block' : 'd-none'">
        <div class="row">
            <div class="col-md-4 position-relative d-none d-md-block text-center">
                <img src="images/payment_img.png" class="img-fluid">
            </div>
            <div class="col-md-8 pervious-transaction-details-status">
                <div>
                    <div class="webSDK-placeholder"></div>
                    <div class="webSDK-container toggle-content item100">
                        <div class="item100  mt-3 form-group" [ngClass]="cardNameError !== '' ? 'has-error' : ''">
                            <label for="cardHolderName">Card Holder Name <span
                                    class="required_field ms-1">*</span></label>
                            <input type="text" class="form-control" placeholder="Card Holder Name"
                                (input)="onInputNameChange($event)" id="cardHolderName" name="cardHolderName"
                                value="" />
                            <div class="validation_msg" id="scard-errors" role="alert">{{cardNameError}}
                            </div>
                        </div>
                        <div class="item100 mt-3 form-group" id="card_number"
                            [ngClass]="cardNumberError !== '' ? 'has-error' : ''">
                            <label>
                                Credit or Debit Card <span class="required_field ms-1">*</span>
                            </label>
                            <div id="card-number" class="form-control p-2">
                            </div>
                            <div class="validation_msg" id="scard-errors" role="alert">{{cardNumberError}}
                            </div>
                        </div>
                        <div class="row mt-3">
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <div class="form-group" id="card_expiry"
                                        [ngClass]="cardExpiryError !== '' ? 'has-error' : ''">
                                        <label>
                                            Expiration date <span class="required_field ms-1">*</span>
                                        </label>
                                        <div id="card-expiry" class="form-control p-2">
                                        </div>
                                        <div class="validation_msg" id="scard-errors" role="alert">
                                            {{cardExpiryError}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="col-lg-6">
                                <div class="form-group">
                                    <div class="item100" id="card_cvc"
                                        [ngClass]="cardCVVError !== '' ? 'has-error' : ''">
                                        <label>
                                            CVV Code <span class="ms-1 required_field ms-1">*</span>
                                        </label>
                                        <div id="card-cvc" class="form-control p-2">
                                        </div>
                                        <div class="validation_msg" id="scard-errors" role="alert">
                                            {{cardCVVError}}
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>

                    </div>
                </div>
                <pre class='container' id='result'></pre>
            </div>
        </div>
    </div>

    <div *ngIf="paymentSession?.sessionToken === ''">
        <p class="line-height-25 mb-0">
            <span class="wid-30 hei-30 f-14 me-2 border-radius-50 badge bg-warning line-height-25">
                <i class="fa fa-regular fa-exclamation"></i>
            </span>
            Please note that a required merchant configuration is missing. In order to process payments successfully,
            it's essential to set up the merchant configuration. If you require assistance or have any questions,
            please reach out to our support team for prompt assistance. Thank you for your attention to this matter.
        </p>
    </div>

</div>